import React from "react"
import { IConsolidado, IDiffReadingTotal } from "./utils/interfaces"
import { objetoVacio } from "util/utils"

export const INITIAL_STATE: INITIAL_STATE = {
    estacion: null,
    departamento: '',
    ciudad: '',
    fecha: new Date(),
    deshabilitarConciliarDia:false,
    deshabilitarConciliarVentas:false,
}

interface INITIAL_STATE {
    estacion: number | null,
    departamento: string,
    ciudad: string,
    fecha: Date,
    deshabilitarConciliarDia:boolean
    deshabilitarConciliarVentas:boolean
}

export interface IPropsFormConciliador {
    form: INITIAL_STATE,
    setForm: React.Dispatch<React.SetStateAction<INITIAL_STATE>>,
    handlerForm: (name: string, e: any) => void,

    onSumbit: () => void,
    loading: boolean
}

export interface IOptionInfoEDS extends IEstacionInfo {
    label: string
    value: number
}
export interface IEstacionInfo {
    id: string;
    alias: string;
    pais: string;
    ciudad: string;
    departamento: string;
}

export interface Atributos {
    contactos: Contacto[];
    pais: Ciudad;
    provincia: Ciudad;
    ciudad: Ciudad;
    tipo_unidad: string;
    minimo_valor: number;
    centro_logistico: string;
    centro_beneficio: string;
    descriptores: Descriptores;
}

export interface Ciudad {
    value: number;
    label: string;
}

export interface Contacto {
    descripcion: string;
    contacto: string;
    tipo: number;
    principal: string;
}

export interface Descriptores {
    header: string;
    footer: string;
}

export interface Parametros {
}

const FORMAS_PAGO: any = {
    'OTROS MEDIOS DE PAGOS': 'otros_medios_pagos',
    PRIVADA: 'marcas_privadas',
    CONTADO: 'contado',
    RECAUDO: 'recaudo',
    'CONSUMO INTERNO': 'consumo_interno',
    CREDITO: 'credito'
};

const DEDAULT_FORMA_PAGO = {
    total: 0,
    detalle: []
}

export const parseResponseConsolidado = (array: any): IConsolidado => {
    const data: any = {};

    array.forEach((forma: any) => {
        try {
            data[FORMAS_PAGO[forma.forma_pago]] = {
                total: Number(forma.valor_venta),
                detalle: forma.listado_conciliador.map((medio: any) => ({
                    medio_pago: medio.descripcion,
                    total: medio.total_venta,
                })),
            };
        } catch (error) {
            console.log(error);
            data[FORMAS_PAGO[forma.forma_pago]] = DEDAULT_FORMA_PAGO
        }

    });

    return data
};


export function createDateInstance(dateString: string) {
    try {
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(year, month - 1, day); // Restamos 1 al mes, ya que en el constructor de Date, los meses van de 0 a 11.
        return date;
    } catch (error) {
        return new Date()
    }
}

export const sortFuntion = (array: any[]) => {
    return array.sort((a, b) => {
        const descripcionA = a.descripcion.toUpperCase(); // Convertir a mayúsculas para una comparación sin distinción de mayúsculas y minúsculas
        const descripcionB = b.descripcion.toUpperCase();
        if (descripcionA < descripcionB) {
            return -1;
        }
        if (descripcionA > descripcionB) {
            return 1;
        }
        return 0; // Si son iguales
    });
}

export const DIFF_READING_DEFAULT: IDiffReadingTotal = {
    calibraciones: 0,
    diferencia_lectura: 0,
    diferencia_manguera: 0,
    venta_total: 0
}

export const parseDifferenceReading = (object: any) => {
    try {
        if (objetoVacio(object)) return []
        const diferenciaFinal: any = []
        Object.entries(object).forEach((turno: any) => {
            const productos = Object.entries(turno[1])
            productos.forEach((producto: any) => {
                diferenciaFinal.push({
                    turno: turno[0],
                    producto: producto[0],
                    ...producto[1]
                })
            })
        })
        return diferenciaFinal
    } catch (error) {
        console.log('ERROR', error);
        return []
    }
}

export interface INotasCreditoParsed {
    contado: {
        total: number;
        detalle: {
            combustible: number;
            kiosco: number;
            canastilla: number;
            cdl: number;
            glp: number;
        };
    };
    marcas_privadas: {
        total: number;
        detalle: {
            combustible: number;
            kiosco: number;
            canastilla: number;
            cdl: number;
            glp: number;
        };
    };
    otros_medios_pagos: {
        total: number;
        detalle: {
            combustible: number;
            kiosco: number;
            canastilla: number;
            cdl: number;
            glp: number;
        };
    };
    consumo_interno: {
        total: number;
        detalle: {
            combustible: number;
            kiosco: number;
            canastilla: number;
            cdl: number;
            glp: number;
        };
    };
    credito: {
        total: number;
        detalle: {
            combustible: number;
            kiosco: number;
            canastilla: number;
            cdl: number;
            glp: number;
        };
    };
    recaudo: {
        total: number;
        detalle: {
            combustible: number;
            kiosco: number;
            canastilla: number;
            cdl: number;
            glp: number;
        };
    };
}

export const parseNotasCredito = (notasCreditoArray: any[]): INotasCreditoParsed => {
    const resultado: INotasCreditoParsed = {
        contado: { total: 0, detalle: { combustible: 0, kiosco: 0, canastilla: 0, cdl: 0, glp: 0 } },
        marcas_privadas: { total: 0, detalle: { combustible: 0, kiosco: 0, canastilla: 0, cdl: 0, glp: 0 } },
        otros_medios_pagos: { total: 0, detalle: { combustible: 0, kiosco: 0, canastilla: 0, cdl: 0, glp: 0 } },
        consumo_interno: { total: 0, detalle: { combustible: 0, kiosco: 0, canastilla: 0, cdl: 0, glp: 0 } },
        credito: { total: 0, detalle: { combustible: 0, kiosco: 0, canastilla: 0, cdl: 0, glp: 0 } },
        recaudo: { total: 0, detalle: { combustible: 0, kiosco: 0, canastilla: 0, cdl: 0, glp: 0 } }
    };

    if (!notasCreditoArray || !Array.isArray(notasCreditoArray)) {
        return resultado;
    }

    notasCreditoArray.forEach((nota: any) => {
        if (!nota.medios_pago_discriminados || !Array.isArray(nota.medios_pago_discriminados)) {
            return;
        }

        nota.medios_pago_discriminados.forEach((medio: any) => {
            const valorTotal = Number(medio.valor_total) || 0;
            const codigoDian = medio.codigo_dian;
            const medioPagoId = medio.medio_pago_id;
            
            // Determinar el tipo de pago
            let tipoPago: 'contado' | 'credito' | 'otros_medios_pagos' | 'recaudo' | 'marcas_privadas' | 'consumo_interno' = 'contado';
            
            if (codigoDian === '10') {
                tipoPago = 'contado'; // EFECTIVO
            } else if (codigoDian === 'ZZZ' || medioPagoId === 8) {
                tipoPago = 'credito'; // CREDITO
            } else if (codigoDian === '48' || medioPagoId === 5) {
                tipoPago = 'otros_medios_pagos'; // TARJETA CREDITO
            } else if (codigoDian === '49') {
                tipoPago = 'recaudo';
            }

            // Sumar valores por producto (Combustible, Kiosco, Canastilla, CDL, GLP)
            // En notas de crédito, todos los valores deben ser negativos excepto Crédito
            // Nota: El backend envía "kiosko" (con 'o'), por lo que se busca con ambas variantes
            const combustible = Number(medio.combustible) || 0;
            const kiosco = Number(medio.kiosko) || Number(medio.kiosco) || 0;
            const canastilla = Number(medio.canastilla) || 0;
            const cdl = Number(medio.cdl) || 0;
            const glp = Number(medio.glp) || 0;

            // Para Contado y Otros medios de pago, los valores deben ser negativos (notas de crédito = devolución)
            if (tipoPago === 'contado' || tipoPago === 'otros_medios_pagos') {
                resultado[tipoPago].total -= Math.abs(valorTotal);
                resultado[tipoPago].detalle.combustible -= Math.abs(combustible);
                resultado[tipoPago].detalle.kiosco -= Math.abs(kiosco);
                resultado[tipoPago].detalle.canastilla -= Math.abs(canastilla);
                resultado[tipoPago].detalle.cdl -= Math.abs(cdl);
                resultado[tipoPago].detalle.glp -= Math.abs(glp);
            } else {
                // Para Crédito, mantener valores positivos
                resultado[tipoPago].total += Math.abs(valorTotal);
                resultado[tipoPago].detalle.combustible += Math.abs(combustible);
                resultado[tipoPago].detalle.kiosco += Math.abs(kiosco);
                resultado[tipoPago].detalle.canastilla += Math.abs(canastilla);
                resultado[tipoPago].detalle.cdl += Math.abs(cdl);
                resultado[tipoPago].detalle.glp += Math.abs(glp);
            }
        });
    });

    return resultado;
}